module.exports = new __parcel__URL__("titan1.0ecf1a25.png").toString();